// Tabs Plugin v0.0.1 for jQuery
// =============
// Author: Denis Lyashkov
// Created: 28/10/2015
// Date: 28/10/2015
// Website:
// Description:

(function ($) {
	var key = 'mi-tabs';
	var defaults = {
		element: 'a',
		tabAttr: 'href',
		contentClass: 'tabs-content',
		triggerEvent: 'click',
		hideClass: 'hidden',
		onChange: function () {
			return false;
		},
        onInit: function(){

		}
	};

	var methods = {
		init: function (params) {
			var options = $.extend({}, defaults, params);

            var callBack = options.onInit;
            if (typeof callBack === 'function') {
                callBack.call(this, this);
            }

			return this.each(function () {
				var $this = $(this);
				var data = $this.data(key);

				if (!data) {
					$this.data(key, {
						target: $this,
						options: options
					});

					$(this).on(options.triggerEvent, options.element, function (e) {

						e.preventDefault();
						var tab = $(this).attr(options.tabAttr);
						$('.' + options.contentClass).addClass(options.hideClass);
						$(tab).removeClass(options.hideClass);

						var callBack = options.onChange;
						if (typeof callBack === 'function') {
							callBack.call(this, this, tab);
						}

						return false;
					});
				}
			});
		},
		setTab: function (tabId) {
			return this.each(function () {
				var $this = $(this);
				var data = $this.data(key);
				if (data) {
					var options = data.options;
					$('.' + options.contentClass).hide();
					$(tabId).show();
					var tabController = $this.find(options.element + '[' + options.tabAttr + '="' + tabId + '"]');
					tabController.click();
				}
			});
		}
	};

	jQuery.fn.tabs = function (method)
	{
		if (methods[method]) {
			return methods[ method ].apply(this, Array.prototype.slice.call(arguments, 1));
		} else if (typeof method === 'object' || !method) {
			return methods.init.apply(this, arguments);
		} else {
			$.error('Method ' + method + ' is not exists');
		}
	};

})(jQuery);